import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Import redux
import { getSpecificRole } from "../../../../redux/features/Settings/Management/Roles";

// Import components
import Loader from "../../../../components/Loader/Index";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import formatDateViewAll from "../../../../utils/formatDateViewAll";

// Import utils

const RoleDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // switcher tabs states
  const [showRoleDetails, setShowRoleDetails] = useState(true);
  const [showFeatures, setShowFeatures] = useState(false);

  const { specificRoleData, specificRoleLoading } = useSelector(
    (state) => state?.roles,
  );

  let rolesDetailsData = specificRoleData?.roles?.[0];

  let featuresDetails = specificRoleData?.features;

  useEffect(() => {
    const getRoleInfo = async () => {
      try {
        await dispatch(getSpecificRole(id));
      } catch (error) {
        console.error(error);
      }
    };

    getRoleInfo();
  }, [dispatch, id]);

  const toggleRoleDetails = () => {
    setShowRoleDetails(true);
    setShowFeatures(false);
  };

  const toggleRoleFeatures = () => {
    setShowRoleDetails(false);
    setShowFeatures(true);
  };

  return (
    <div className="flex flex-col overflow-y-auto bg-primary-bg h-full-height">
      {specificRoleLoading ? (
        <div className="flex items-center justify-center loader-container m-auto">
          <Loader />
        </div>
      ) : rolesDetailsData ? (
        <>
          <div className="hidden Qsmd:block Qsmd:h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
          {/* Responsive page header */}
          <div className="Qsmd:hidden fixed w-width-full p-padding-sm top-top-base bg-primary-nav flex items-center z-z-index-fixed-ui rounded-b-border-radius-md shadow-box-shadow-bottom">
            <div
              className="pl-padding-sm pr-padding-md cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <SVGComponent
                url={
                  "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                }
                color="var(--text-primary)"
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
              />
            </div>
            <div className="flex flex-col">
              <p className="text-font-md text-text-primary font-normal">Role</p>
              <p className="text-font-xs text-text-primary font-normal">
                Detail page
              </p>
            </div>
          </div>
          {/* ---------------------- */}
          <div className="w-width-full bg-primary-nav">
            <div className="max-w-tab-width-normal mx-auto Qsmd:px-padding-md Qlg:px-padding-base">
              <div className="flex flex-col pt-padding-xl mt-margin-md Qsmd:pt-padding-base Qsmd:mt-margin-base px-padding-md Qlg:px-padding-base Qsmd:px-padding-md">
                <div className="flex-1 py-padding-md px-padding-md Qsmd:pl-padding-sm Qsmd:pr-padding-md border-b border-solid border-primary-bg">
                  <TitleSubtitlePair
                    title={rolesDetailsData?.role_name}
                    subtitle={"Role name"}
                    titleColor={"text-primary"}
                    isBold={false}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
                <div className="flex-1 py-padding-md px-padding-md Qsmd:pl-padding-sm Qsmd:pr-padding-md">
                  <TitleSubtitlePair
                    title={
                      rolesDetailsData?.is_deleted === "Y"
                        ? "Inactive"
                        : "Active"
                    }
                    subtitle={"Status"}
                    titleColor={
                      rolesDetailsData?.is_deleted === "Y"
                        ? "failed"
                        : "settled"
                    }
                    isBold={true}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Switcher Tab & Additional Details of User */}
          <div>
            <div className="m-auto max-w-tab-width-normal">
              <div className="flex pt-padding-md px-padding-md Qlg:px-padding-base">
                <div className="flex gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                  <SwitcherTabs
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                        handler: toggleRoleDetails,
                      },
                      {
                        label: "Features",
                        key: "features",
                        handler: toggleRoleFeatures,
                      },
                    ]}
                    initialActiveTab={showFeatures ? "features" : "details"}
                  />
                </div>
              </div>
              {showRoleDetails ? (
                <div className="flex flex-col Qsmd:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md">
                  <CommonDetailCard
                    cardTitle="Role Description"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Description",
                        content: rolesDetailsData?.role_desc,
                        type: "text",
                      },
                    ]}
                  />

                  <CommonDetailCard
                    cardTitle="Origin Details"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Created by",
                        content: rolesDetailsData?.created_by,
                        type: "text",
                      },
                      {
                        heading: "Created on",
                        content: formatDateViewAll(
                          rolesDetailsData?.created_on,
                          true,
                          true,
                        ),
                        type: "text",
                      },
                    ]}
                  />
                  <CommonDetailCard
                    cardTitle="Support Information"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Role ID",
                        content: rolesDetailsData?.role_id,
                        type: "text",
                      },
                    ]}
                  />
                </div>
              ) : showFeatures ? (
                featuresDetails?.length > 0 ? (
                  <div className="flex flex-row flex-wrap my-margin-md px-padding-md lg:px-padding-base gap-gap-md">
                    {featuresDetails?.map((featureInfo) => {
                      return (
                        <>
                          <CardContainer
                            key={featureInfo?.feature_id}
                            context={featureInfo}
                            isNoHoverRequired={false}
                            isDisabled={false}
                            isSelected={false}
                            onClickHandler={() => {
                              navigate(
                                `/settings/feature_view_all/feature_detail_page/${featureInfo?.feature_id}`,
                              );
                            }}
                          >
                            <card-body>
                              <TextWithIcon
                                type={"text"}
                                fontWeight={"normal"}
                                text={featureInfo?.feature_name}
                                subText={"Feature name"}
                                textColor={"var(--text-primary)"}
                              />
                              <TextWithIcon
                                type={"text"}
                                fontWeight={"normal"}
                                text={featureInfo?.feature_description}
                                subText={"Feature description"}
                                textColor={"var(--text-primary)"}
                              />
                            </card-body>
                          </CardContainer>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    <div className="mt-margin-md pb-padding-md">
                      <CommonContainerCard header="Features">
                        <div className="flex flex-row flex-wrap gap-gap-sm">
                          <p className="text-font-sm text-text-primary">
                            No features assigned
                          </p>
                        </div>
                      </CommonContainerCard>
                    </div>
                  </>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RoleDetails;
